module.exports = __webpack_public_path__ + "img/宿迁国际汽车城产业发展有限公司.70f3c617.png";